/**
 * name: `global_active_${name}_${yymmdd}` // 弹框命名规则
 * des: 事件描述
 * entry: 事件对应文件入口，便于查找
 * routers: [], // 可选项，限制事件执行的路由集合 ， 空集合或不设置默认为全部路由
 * run: 1, // // 可选项 | 事件执行总次数, 不设置默认为1, | -1 为无限制执行次数
 * finished: 0, // 可选项 | 事件执行次数统计
 * extend 扩展参数最终 再事件回调中传入
 */
// 顺序配置
export const config = [
  {
    // 大白号提示
    name: "global_active_campaignModal_20250110",
    des: "大白号提示框",
    entry: "@/layouts/globalModals/CampaignModal",
    routers: [
      "/hr/recruiter/home",
      "/hr/recruiter/campaign",
      "/hr/recruiter/dashboard",
      "/hr/recruiter/linkin",
      "/hr/recruiter/campaignDetail",
      "/hr/recruiter/dialogue",
      "/sales/salesReps/home",
      "/sales/salesReps/campaign",
      "/sales/salesReps/dashboard",
      "/sales/salesReps/linkin",
      "/sales/salesReps/campaignDetail",
      "/sales/salesReps/dialogue",
    ],
    unrouters: [], // 排除掉的路由
    extend: {},
  },
  {
    name: "global_active_freeModal_20241101",
    des: "免费账号，续费提示框",
    entry: "@/layouts/globalModals/FreeModal",
    routers: [],
    unrouters: [], // 排除掉的路由
    extend: {},
  },
  {
    name: "global_active_bindCardModal_20260802",
    des: "campaign已配置后提示绑卡发布/重新编辑的不可关闭弹框",
    entry: "@/layouts/globalModals/bindCardModal",
    routers: [
      "/hr/recruiter/campaign",
      "/hr/recruiter/campaignDetail",
      "/sales/salesReps/campaign",
      "/sales/salesReps/campaignDetail",
    ],
    unrouters: [
      "/setting/pricing/plan",
      "/setting/userSetting/plan",
      "/hr/recruiter/createCampaign",
      "/sales/salesReps/createCampaign",
    ], // 在绑卡/重新编辑页隐藏
    extend: {},
  },
];
